import { MuiClassCollection } from "../../foundations/mui-class-collection.es.js";
import { Primary, Common } from "../../foundations/palette.es.js";
import { BorderRadius } from "../../foundations/border-radius.es.js";
const listItemButtonOverrides = {
  root: {
    borderRadius: BorderRadius.brand,
    [`&.${MuiClassCollection.selected}, &.${MuiClassCollection.selected}:hover`]: {
      backgroundColor: Primary.main,
      color: Common.white.main
    }
  }
};
export {
  listItemButtonOverrides
};
//# sourceMappingURL=styles.es.js.map
